module.exports = __webpack_public_path__ + "media/customizations/moonlight/old_logo-ca67147cefbe16646758fd7c7d808866.png";